import {
	saveDataBoxAllAttachmentsToDocumentsQuery,
	useAxiosInstance,
	usePoMutation,
} from '@gov-nx/api';
import { useMessageEvents } from '@gov-nx/core/events';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { isFulfilled, isRejected } from '@gov-nx/core/types';
import { PageCode } from '@gov-nx/module/page';

export interface SaveAttachmentToDocumentsProps {
	onError: () => void;
	onSuccess: () => void;
}

export const useSaveAllAttachmentsToDocuments = ({
	onSuccess,
	onError,
}: SaveAttachmentToDocumentsProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const { axiosInstance } = useAxiosInstance();

	const { toastMessageError, toastMessageSuccess } = useMessageEvents();

	const saveAllAttachmentsToDocuments = usePoMutation({
		mutationFn: saveDataBoxAllAttachmentsToDocumentsQuery(axiosInstance),
		onSuccess: (data) => {
			const successCount = data.filter(isFulfilled).length;
			const errorResponses = data.filter(isRejected);

			if (errorResponses.length) {
				onError && onError();

				let errorMessage = '';

				const errorExtDesc =
					errorResponses[0].reason?.response?.data?.chyby?.[0]?.extPopis;
				const errorDesc =
					errorResponses[0].reason?.response?.data?.chyby?.[0]?.popis;

				if (errorExtDesc) {
					errorMessage = errorExtDesc;
				} else if (errorDesc) {
					errorMessage = errorDesc;
				} else {
					errorMessage = tn('akce.prilohy-ulozeny', { count: successCount });
				}

				toastMessageError(errorMessage);
			} else {
				onSuccess && onSuccess();

				toastMessageSuccess(
					successCount === 1
						? tn('akce.priloha-ulozena')
						: tn('akce.prilohy-ulozeny', { count: successCount })
				);
			}
		},
	});
	return saveAllAttachmentsToDocuments;
};
